export default "__VITE_ASSET__a35ca1e9__"